import { canPrecisionPolicyFilterEditSelector, getUserProfile } from '@src/store/common/selectors';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import { OPEN_FILTER_MANAGEMENT_EVENT } from '@src/components/filter/index';
import { isAdmin } from '@src/components/filter/components/utils';
import { USER_ROLE_READONLY } from '@src/utils/constants';

const EditFilterButton = ({ policy }) => {
  const user: any = useSelector(getUserProfile);
  const canEditPolicyFilter = useSelector(canPrecisionPolicyFilterEditSelector);
  const handleEditClick = () => {
    window.dispatchEvent(
      new CustomEvent(OPEN_FILTER_MANAGEMENT_EVENT, {
        detail: {
          editFilterId: policy.id,
        },
      }),
    );
  };

  // consistence with checkCanEdit method
  const canEdit = useMemo(() => {
    if (user.role === USER_ROLE_READONLY) return false;
    if (!policy.isFilterEditable) return false;
    if (!user['can_edit_policies'] || !canEditPolicyFilter) return false;
    if (isAdmin(user.role)) return true;
    return user.username === policy.creator;
  }, [user, policy]);

  return (
    <Button type="primary" ghost onClick={handleEditClick} size="small" disabled={!canEdit}>
      Edit
    </Button>
  );
};

export default EditFilterButton;
